export default __webpack_public_path__ + "static/media/onedrive-icon.b5079de7.svg";